module.exports = "<div disable-tooltip-on-overflow>\n\t<i class=\"icon icon-info\"\n\t   ng-if=\"!row.entity.license.valid_license\"\n\t   jf-tooltip=\"{{row.entity.license.license_status_message}}\"></i>\n\t{{row.entity.name}}\n</div>"


//////////////////
// WEBPACK FOOTER
// ./modules/distribution/services/sharedViewTemplate/distribution.site.cell.template.html
// module id = 46
// module chunks = 6